import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ContentBlock } from '../../models';
import { BaseContent } from 'src/app/content/models';
import { Theme } from 'src/app/themes/models';

@Component({
  selector: 'app-content-block-themes',
  templateUrl: './content-block-themes.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentBlockThemesComponent {
  @Input({ required: true }) block!: ContentBlock;
  @Input() content: BaseContent[] = [];
  @Input() themes: Theme[] = [];
  @Input() theme?: Theme;
}
